// extracted by mini-css-extract-plugin
export var employeeList = "styles-module--employeeList--Kf4ls";
export var employeeListItem = "styles-module--employeeListItem--HbIAF";